import React, { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { GoPrimitiveDot } from "react-icons/go";
import { useMutation } from "@apollo/react-hooks";
import { APP_CONTEXT } from "../../../utils/context";
import PageHeader from "../../../components/PageHeader/PageHeader.component";
import { Row, Column } from "../../../components/Grid/Grid.component";
import Form from "./UserType.form.component";
import Button from "../../../components/Button/Button.component";
import Error from "../../../components/Error/ErrorMessage.component";
import BorderSelect from "../../../components/Form/BorderSelect/BorderSelect.component";
import Notification from "../../../components/Toast/Toast.component";
import { PermissionsList } from "./permissionsList";

// GQL
import { CREATE_USER_TYPE } from "../../../graphql/mutations/userType.mutation";
import { formatGraphqlError } from "../../../utils/api";

const UserTypeNew = () => {
  const { setActiveSideNav, setPageTitle } = useContext(APP_CONTEXT);
  const [userTypeData, setUserTypeData] = useState({
    id: "",
    title: "",
    description: "",
    status: "ACTIVE",
    permissions: PermissionsList,
  });
  const [createUserType, { loading }] = useMutation(CREATE_USER_TYPE);

  const history = useHistory();

  useEffect(() => {
    setActiveSideNav("sysConf");
    setPageTitle("Create New User Type");
  });

  const { register, handleSubmit, errors, setValue, getValues } = useForm();

  const changeStatus = (e) => {
    const tempUserTypeData = { ...userTypeData };
    tempUserTypeData.status = e.target.value;
    setUserTypeData(tempUserTypeData);
  };

  const getColor = () => {
    switch (userTypeData.status) {
      case "ACTIVE":
        return "#39C568";
      case "ARCHIVE":
        return "#FF003A";
      case "DRAFT":
        return "#707172";
      default:
        return "#707172";
    }
  };

  const onSubmit = (values) => {
    /**
     * Create new User Type
     * push to list all user types
     */

    createUserType({
      variables: {
        ...values,
      },
    })
      .then(() => {
        Notification.success({
          title: "Create User Type Succeeded",
          message: "",
        });
        history.push("/app/system-configuration/user-types");
      })
      .catch((err) =>
        Notification.error({
          title: "Create User Type Failed",
          message: formatGraphqlError(err),
        })
      );
  };

  return (
    <>
      <PageHeader title="Create New User Type" back />
      <Row>
        <Column width="70%" noPad>
          <Form
            register={register}
            errors={errors}
            userTypeData={userTypeData}
            setUserTypeData={setUserTypeData}
            setValue={setValue}
            getValues={getValues}
          />
        </Column>
        <Column width="30%">
          <BorderSelect
            header="Status"
            name="status"
            label="Please select a status"
            value={userTypeData.status}
            register={register}
            onChange={changeStatus}
            options={[
              { value: "ACTIVE", text: "Active" },
              { value: "ARCHIVE", text: "Archive" },
              { value: "DRAFT", text: "Draft" },
            ]}
            icon={
              <GoPrimitiveDot style={{ color: getColor(), fontSize: "25px" }} />
            }
            margin="60px 0px 120px 0px"
            required={{
              required: "please enter a User Type ID",
              pattern: {
                value: /^[a-zA-Z]+$/,
                message: "field cannot be empty",
              },
            }}
            error={errors.id && <Error message={errors.id.message} />}
          />

          <Button
            width="100%"
            onClick={handleSubmit(onSubmit)}
            type="button"
            kind="secondary"
            value="Create User Type"
            loading={loading}
          />
          <Button
            width="100%"
            onClick={() => history.goBack()}
            type="button"
            value="Cancel"
            loading={loading}
          />
        </Column>
      </Row>
    </>
  );
};

export default UserTypeNew;
